import $ from "jquery";

const initNavigationDropdown = () => {
  const buttonsCollection = document.getElementsByClassName(
    "js-navigation-dropdown",
  );

  if (!buttonsCollection || !buttonsCollection.length) {
    return;
  }

  const activeClass = "active";
  const ESC_BTN = 27;
  const $document = $(document);

  function showDropdown(buttonElem) {
    buttonElem.classList.add(activeClass);
    buttonElem.isOpened = true;

    const nextDropdown = buttonElem.nextElementSibling;
    if (nextDropdown) {
      nextDropdown.classList.add(activeClass);
    }
  }

  function hideDropdown(buttonElem) {
    buttonElem.classList.remove(activeClass);
    buttonElem.isOpened = false;

    const nextDropdown = buttonElem.nextElementSibling;
    if (nextDropdown) {
      nextDropdown.classList.remove(activeClass);
    }
  }

  function hideAllDropdowns(currentTarget) {
    Array.from(buttonsCollection).forEach((elem) => {
      if (elem === currentTarget) {
        return;
      }
      hideDropdown(elem);
    });
  }

  function createBodyClickHandler(buttonElem) {
    return function bodyClickHandler(event) {
      const parentWrap = buttonElem.parentElement;

      if (parentWrap && parentWrap.contains(event.target)) {
        return;
      }

      hideDropdown(buttonElem);
      $document.off("click touchstart", bodyClickHandler);
    };
  }

  function createEscapeHandler(buttonElem) {
    return function escapeKeyHandler(event) {
      if (event.keyCode !== ESC_BTN) {
        return;
      }
      hideDropdown(buttonElem);
      $document.off("keyup", escapeKeyHandler);
    };
  }

  Array.from(buttonsCollection).forEach((elem) => {
    elem.isOpened = false;

    $(elem).on("click touchstart", (event) => {
      const targetBtn = event.currentTarget;
      const nextDropdown = targetBtn.nextElementSibling;

      if (nextDropdown && nextDropdown.contains(event.target)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      hideAllDropdowns(targetBtn);

      if (!targetBtn.isOpened) {
        showDropdown(targetBtn);
        $document.on("click touchstart", createBodyClickHandler(targetBtn));
        $document.on("keyup", createEscapeHandler(targetBtn));
      } else {
        hideDropdown(targetBtn);
      }
    });
  });
};

export default initNavigationDropdown;
